/*********************
 * Mobillor Technologies Pvt. ltd. CONFIDENTIAL
 * __________________
 *
 *  Mobillor Technologies Pvt. Ltd.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobillor Technologies Pvt. Ltd.
 * The intellectual and technical concepts contained
 * herein are proprietary to Mobillor Technologies Pvt. Ltd.
 * may be covered by Rebublic Of India and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobillor Technologies Pvt. Ltd.
 */

import {
  GET_CALENDARS_REQUEST,
  GET_CALENDARS_SUCCESS,
  GET_CALENDARS_FAILURE,
  CREATE_CALENDAR_REQUEST,
  CREATE_CALENDAR_SUCCESS,
  CREATE_CALENDAR_FAILURE,
  UPDATE_CALENDAR_REQUEST,
  UPDATE_CALENDAR_SUCCESS,
  UPDATE_CALENDAR_FAILURE,
  DELETE_CALENDAR_REQUEST,
  DELETE_CALENDAR_SUCCESS,
  DELETE_CALENDAR_FAILURE,
  GET_CALENDARS_FOR_HOME_REQUEST,
  GET_CALENDARS_FOR_HOME_SUCCESS,
  GET_CALENDARS_FOR_HOME_FAILURE,
} from "./calendarTypes";

const initialState = {
  loading: false,
  calendars: {},
  error: "",
};

const getCalendarsReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_CALENDARS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_CALENDARS_SUCCESS:
      return {
        loading: false,
        calendars: action.payload,
        error: "",
      };
    case GET_CALENDARS_FAILURE:
      return {
        loading: false,
        calendars: {},
        error: action.payload,
      };
    default:
      return state;
  }
};

const initialStateForCreate = {
  loading: false,
  calendar: {},
  error: "",
};

const createCalendarReducer = (state = initialStateForCreate, action) => {
  switch (action.type) {
    case CREATE_CALENDAR_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case CREATE_CALENDAR_SUCCESS:
      return {
        loading: true,
        calendar: action.payload,
        error: "",
      };
    case CREATE_CALENDAR_FAILURE:
      return {
        loading: false,
        calendar: {},
        error: action.payload,
      };
    default:
      return state;
  }
};

const initialStateForUpdate = {
  loading: false,
  calendar: {},
  error: "",
};

const updateCalendarReducer = (state = initialStateForUpdate, action) => {
  switch (action.type) {
    case UPDATE_CALENDAR_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case UPDATE_CALENDAR_SUCCESS:
      return {
        loading: true,
        calendar: action.payload,
        error: "",
      };
    case UPDATE_CALENDAR_FAILURE:
      return {
        loading: false,
        calendar: {},
        error: action.payload,
      };
    default:
      return state;
  }
};

const initialStateForDelete = {
  loading: false,
  calendar: {},
  error: "",
};

const deleteCalendarReducer = (state = initialStateForDelete, action) => {
  switch (action.type) {
    case DELETE_CALENDAR_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case DELETE_CALENDAR_SUCCESS:
      return {
        loading: true,
        calendar: action.payload,
        error: "",
      };
    case DELETE_CALENDAR_FAILURE:
      return {
        loading: false,
        calendar: {},
        error: action.payload,
      };
    default:
      return state;
  }
};

const initialStateForHome = {
  loading: false,
  calendars: {},
  error: "",
};

const getCalendarsForHomeReducer = (state = initialStateForHome, action) => {
  switch (action.type) {
    case GET_CALENDARS_FOR_HOME_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_CALENDARS_FOR_HOME_SUCCESS:
      return {
        loading: false,
        calendars: action.payload,
        error: "",
      };
    case GET_CALENDARS_FOR_HOME_FAILURE:
      return {
        loading: false,
        calendars: {},
        error: action.payload,
      };
    default:
      return state;
  }
};

export {
  getCalendarsReducer,
  createCalendarReducer,
  updateCalendarReducer,
  deleteCalendarReducer,
  getCalendarsForHomeReducer,
};
